import ChangeAddressService from "../../services/ChangeAddressService";
export const SET_MEMBER_ADDRESS = "SET_MEMBER_ADDRESS";

export function changeAddress(changeAddressObj) {
  let service = new ChangeAddressService();
  return dispatch =>
    service.UpdateMemberAddress(changeAddressObj).then(data => {
      dispatch({
        type: SET_MEMBER_ADDRESS,
        payload: {
          MemberAddress: changeAddressObj
        }
      });
      return data;
    });
}
